import { BrandPhoneMockups } from "./BrandPhoneMockups"

export const BrandSection = () => {
    const features = [
        'Minimal looking templates',
        'Easy link sharing',
        'quickly generate your spelltrees',
        'Regular template additions'
    ]

    return (
        <section className="py-20 px-6 bg-gray-50 text-black">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row items-center gap-12">
                    <div className="flex-1">
                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1] mb-6">
                            Effortless online presence
                        </h2>
                        {/* <p className="text-xl md:text-2xl font-medium leading-relaxed mb-6">
                            Showcase your work with our intuitive platform.
                        </p> */}
                        <FeatureList features={features} />
                        <div className="text-lg text-gray-500 mt-4">
                            Thoughtfully designed for minimal look.
                        </div>
                    </div>
                    <BrandPhoneMockups />
                </div>
            </div>
        </section>
    )
}

const FeatureList = ({ features }) => {
    return (
        <div className="flex flex-col gap-4">
            {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-black flex items-center justify-center text-white text-sm">
                        ✓
                    </div>
                    <span className="text-lg">{feature}</span>
                </div>
            ))}
        </div>
    )
}